/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_DehumidifierInputs */



/**
* | output |
* | --- |
* | "Dehumidifier" |
*
* @param {Air_Handler_Unit_DehumidifierInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_dehumidifier = /** @type {((inputs?: Air_Handler_Unit_DehumidifierInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_DehumidifierInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Dehumidifier")
	return /** @type {LocalizedString} */ ("Déshumidificateur")
});